import React, { useEffect, useState } from "react";
import AssignedEmpListTable from "./Components/AssignedEmpListTable";
import AddAssign from "./Components/AddAssign";
import { useNavigate } from "react-router-dom";
import { hasAddAccess } from "../../Common/CheckAccess";

const AssignedEmployeeList = () => {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  const handleAddGuest = () => {
    navigate("/front-desk/guest-management/add", {
      state: { mode: "create" },
    });
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Guest Management</h3>
            <div className="col-auto d-flex w-sm-100">
              {hasAddAccess(permissions, "front_desk") && (
                <button className="btn btn-dark" onClick={handleAddGuest}>
                  Add Guest
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <AssignedEmpListTable />
            </div>
          </div>
        </div>
      </div>
      <AddAssign />
    </div>
  );
};

export default AssignedEmployeeList;
